import { Api } from "../../Api";

export const getAllNFTsService = async (
  limit: number = 20,
  page: number = 1
) => {
  let url = `/nft/get-nft?limit=${limit}&page=${page}`;
  const response = await Api.get(url);
  return response;
};

export const getFeaturedCollectionsService = async (
  limit: number = 3,
  page: number = 1
) => {
  let url = `/collection/get-featured-collection?limit=${limit}&page=${page}`;
  const response = await Api.get(url);
  return response;
};

export const getTrendingCollectionService = async (
  page: number,
  duration: string
) => {
  let url = `/collection/get-trending-collection?`;

  if (page) {
    url += `page=${page}&`;
  }

  if (duration) {
    url += `time=${duration}&`;
  }

  url = url.endsWith("&") ? url.slice(0, -1) : url;

  const response = await Api.get(url);
  return response;
};

// Not used
export const getAIRankingNFTsService = async (
  limit: number = 10,
  page: number = 1
) => {
  let url = `/nft/get-nft-ranking?limit=${limit}&page=${page}`;
  const response = await Api.get(url);
  return response;
};

export const getFeaturedNFTsService = async () => {
  let url = `/nft/get-feature-fix-list`;
  const response = await Api.get(url);
  return response;
};

export const getFilteredNFTsService = async (
  limit: number = 10,
  page: number = 1,
  name: string = "",
  blockchain_network: string = "",
  rank_by: string = "",
  category_id: string,
  eco_category_id: string
) => {
  const payload = {
    ...(name && { name }),
    ...(blockchain_network && { blockchain_network }),
    ...(rank_by && { rank_by }),
    ...(category_id && { category_id }),
    ...(eco_category_id && { eco_category_id }),
  };
  let url = `/nft/filter-nft?limit=${limit}&page=${page}`;
  const response = await Api.post(url, payload);
  return response;
};

export const getCategoriesService = async () => {
  let url = `/category/getCategory`;
  const response = await Api.get(url);
  return response;
};
